import { useTheme } from '@mui/material/styles';
import { pathOr } from 'ramda';
import { base64Decode } from "src/utilities/base64";
import React from 'react';
import ProductContainer from 'src/features/Auth/SignUp/ProductContainer';
import SiteSettings from 'src/siteSetting';
import { getQueryParam } from 'src/utilities/queryParams';
import { getLoanProductByNamespace } from 'src/services/grapqlQueries/loanProductQuery';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { getAdvisorSubProducts } from './advisorProduct';

const AdvisorProductLanding: React.FC<any> = (props: any) => {
  const loanProductsEncoded = getQueryParam(location.search, 'products');
  const { data } = getLoanProductByNamespace({
    object_meta: {
      namespace: getNamespaceName(),
    },
  });


  const advisorSubProducts = getAdvisorSubProducts({
      advisorLoanProducts: base64Decode(loanProductsEncoded),
      loanProducts:pathOr([], ['loan_products'], data),
  });

  const theme = useTheme();
  const title = `What <span style='color:${pathOr(
    '',
    ['palette', 'primaryColor'],
    theme
  )};font-family: Martel, serif;'>type of ${SiteSettings.generalGetstartedWithTilesGroup()} financing</span> are you looking for?`;
  return (
    <ProductContainer title={title} advisorSubProducts={advisorSubProducts} />
  );
};

export default AdvisorProductLanding;
